

import SEO from '../../components/SEO';
import Hero from './components/Hero';
import ProductFeatures from './components/ProductFeatures';
import UsageScenes from './components/UsageScenes';
import BrandStory from './components/BrandStory';
import Story from './components/Story';
import Testimonials from './components/Testimonials';
import BrandTrust from './components/BrandTrust';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Deaiwo Sarang Spray",
    "description": "愛する家族に、最高のサラうる体験を。Deaiwoは飼い主の悩みにスキンケア発想で寄り添います。人の肌を整える化粧品ブランドならではのペットケア。ペット用ラグジュアリーブラッシングミスト。",
    "brand": {
      "@type": "Brand",
      "name": "Deaiwo"
    },
    "category": "ペットケア用品",
    "url": siteUrl,
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "JPY"
    }
  };

  return (
    <>
      <SEO 
        title="Deaiwo Sarang Spray | 愛する家族に、最高のサラサラ体験を"
        description="愛する家族に、最高のサラうる体験を。Deaiwo Sarang Spray - Deaiwoは飼い主の悩みにスキンケア発想で寄り添います。人の肌を整える化粧品ブランドならではのペットケア。ペット用ラグジュアリーブラッシングミスト。"
        keywords="ペットケア, 犬猫用スプレー, ブラッシングミスト, Deaiwo, Sarang Spray, ペット美容"
        canonical={siteUrl}
        schema={schema}
      />
      <div className="min-h-screen bg-[#FAF8F5]">
        <Hero />
        <ProductFeatures />
        <UsageScenes />
        <BrandStory />
        <Story />
        <Testimonials />
        <BrandTrust />
        <FAQ />
        <CTA />
        <Footer />
      </div>
    </>
  );
}
